/*
 * mds-event-urgency.js — client tick + dismiss for sections/mds-event-urgency.liquid
 *
 * The server renders the headline with token substitution already done and
 * each numeric token wrapped in <span class="mds-urgency__tick" data-tick="...">.
 * This script updates those spans via textContent on a tick — never innerHTML,
 * never a regex-replace on merchant content. Multi-instance safe.
 *
 * Tick cadence adapts to time remaining:
 *   > 48h       — every 60s (coarse — days change once per day)
 *   24h – 48h   — every 30s
 *   1h – 24h    — every 30s
 *   < 1h        — every 1s  (seconds visible via the minutes span)
 *
 * If the cutoff already passed on page load, the server rendered the
 * post-cutoff copy and this script does nothing to the text — but still
 * wires the dismiss button.
 *
 * Fails silently — the server render is authoritative, so a broken
 * data-cutoff attribute or a localStorage exception doesn't break the
 * storefront.
 */

(function () {
  'use strict';

  var urgencies = document.querySelectorAll('[data-section-type="mds-event-urgency"]');
  if (!urgencies.length) return;

  urgencies.forEach(function (root) {
    try {
      var cutoffIso   = root.getAttribute('data-cutoff');
      var eventName   = root.getAttribute('data-event-name') || '';
      var eventDate   = root.getAttribute('data-event') || '';
      var dismissible = root.getAttribute('data-dismissible') === 'true';

      var cutoffDate = new Date(cutoffIso);
      var cutoffTs = Math.floor(cutoffDate.getTime() / 1000);
      if (!isFinite(cutoffTs)) return;

      // event_date is "YYYY-MM-DD". Match the server's event_end_iso
      // by tagging end-of-day UTC so the days_to_event count drops
      // at midnight local-on-server, matching the Liquid render.
      var eventEndIso = eventDate ? eventDate + 'T23:59:59Z' : '';
      var eventTs = eventEndIso ? Math.floor(new Date(eventEndIso).getTime() / 1000) : NaN;

      if (dismissible) {
        var storageKey = 'mds-urgency-dismissed::' + eventName + '::' + eventDate;
        try {
          if (window.localStorage && window.localStorage.getItem(storageKey) === '1') {
            root.style.display = 'none';
            return;
          }
        } catch (e) { /* localStorage unavailable — render anyway */ }

        var dismissBtn = root.querySelector('[data-dismiss]');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', function () {
            try { window.localStorage.setItem(storageKey, '1'); } catch (err) { /* ignore */ }
            root.style.display = 'none';
          });
        }
      }

      var daysEls       = root.querySelectorAll('[data-tick="days"]');
      var daysEventEls  = root.querySelectorAll('[data-tick="days_to_event"]');
      var hoursEls      = root.querySelectorAll('[data-tick="hours"]');
      var minutesEls    = root.querySelectorAll('[data-tick="minutes"]');
      if (!daysEls.length && !daysEventEls.length && !hoursEls.length && !minutesEls.length) return;

      function setAll(nodes, value) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].textContent !== value) {
            nodes[i].textContent = value;
          }
        }
      }

      function tick() {
        var nowTs = Math.floor(Date.now() / 1000);
        var secondsLeft = cutoffTs - nowTs;
        if (secondsLeft < 0) secondsLeft = 0;

        var days    = Math.floor(secondsLeft / 86400);
        var hours   = Math.floor((secondsLeft % 86400) / 3600);
        var minutes = Math.floor((secondsLeft % 3600) / 60);

        setAll(daysEls,    String(days));
        setAll(hoursEls,   String(hours));
        setAll(minutesEls, String(minutes));

        if (isFinite(eventTs) && daysEventEls.length) {
          var secondsToEvent = eventTs - nowTs;
          if (secondsToEvent < 0) secondsToEvent = 0;
          var daysToEvent = Math.floor(secondsToEvent / 86400);
          setAll(daysEventEls, String(daysToEvent));
        }
      }

      function scheduleNext() {
        var nowTs = Math.floor(Date.now() / 1000);
        var secondsLeft = cutoffTs - nowTs;
        if (secondsLeft <= 0) return;                     // stop ticking after cutoff
        var rateMs;
        if (secondsLeft < 3600) rateMs = 1000;            // < 1h → 1s
        else if (secondsLeft < 172800) rateMs = 30000;    // < 48h → 30s
        else rateMs = 60000;                              // otherwise → 60s

        setTimeout(function () {
          tick();
          scheduleNext();
        }, rateMs);
      }

      // Sync first tick so server-render discrepancies correct immediately.
      tick();
      scheduleNext();
    } catch (err) {
      /* Server-render is authoritative — silent failure is safer than a broken page. */
    }
  });
})();
